import { useWorkspaceContext } from '@core/contexts/workspace-context'
import { useConversation } from '@core/hooks/useConversation'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/_authenticated/$workspaceId/agent')({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspace } = useWorkspaceContext()
  const { enterScope } = useConversation()

  useEffect(() => {
    enterScope(
      { type: 'workspace', workspaceId: workspace.id },
      { label: workspace.name, workspaceId: workspace.id }
    )
  }, [workspace.id, workspace.name, enterScope])

  return <Outlet />
}
